module.exports = __webpack_public_path__ + "static/media/sec2.b05e2138.svg";